import React, {useEffect, useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import {CreateVehiclePlateRequest} from "../../../../models/create-vehicle-plate-request";
import useVehiclePlateService from "../../../../services/backoffice/hooks/useVehiclePlateService";
import {ShortDto} from "../../../../models/short-dto";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import useVehicleTypeService from "../../../../services/backoffice/hooks/useVehicleTypeService";
import useFleetTypeService from "../../../../services/backoffice/hooks/useFleetTypeService";

const CreateVehiclePlate = () => {
    const [plate, setPlate] = useState<Partial<CreateVehiclePlateRequest>>({});
    const navigate = useNavigate();
    const [clientes, setClients] = useState<ShortDto[]>([]);
    const [vehicleTypes, setVehicleTypes] = useState<ShortDto[]>([]);
    const [fleetTypes, setFleetTypes] = useState<ShortDto[]>([]);
    
    const {getAllClientsShortDto} = useClientService();
    const {getAllVehicleTypesShortDto} = useVehicleTypeService();
    const {getAllFleetTypesShortDto} = useFleetTypeService();
    const {createVehiclePlate} = useVehiclePlateService();

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setPlate((prevPlate) => ({
            ...prevPlate,
            [name]: value,
        }));
    };

    useEffect(() => {
        async function loadData() {
            try {
                const clientsResponse = await getAllClientsShortDto();
                setClients(clientsResponse);
                
                const vehicleTypesResponse = await getAllVehicleTypesShortDto();
                setVehicleTypes(vehicleTypesResponse);
                
                const fleetTypesResponse = await getAllFleetTypesShortDto();
                setFleetTypes(fleetTypesResponse);
            } catch (error) {
                console.error('Erro ao carregar dados:', error);
            }
        }

        loadData();
    }, []);

    const handleSubmit = async () => {
        try {
            await createVehiclePlate(plate)
            // handle success
            navigate('/backoffice/vehicle-plates/')
            toast.success('Placa criada com sucesso', ToasterConfig.success);
        } catch (error) {
            toast.error('Erro ao criar placa', ToasterConfig.error);
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Placas / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>
                        <Form.Input
                            label="Placa"
                            name="plate"
                            type="text"
                            placeholder="Placa"
                            value={plate.plate}
                            onChange={handleInputChange}
                            maxLength={11}
                            required
                        />


                        <Form.Input
                            label="Tag"
                            name="tag"
                            type="text"
                            placeholder="Tag do veículo"
                            value={plate.tag}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label="Descrição"
                            name="description"
                            type="text"
                            placeholder="Descrição sobre a placa"
                            value={plate.description}
                            onChange={handleInputChange}
                        />

                        <Form.Select
                            label={'Cliente ao qual a placa pertence'}
                            options={clientes}
                            placeholder='Selecione uma opção'
                            value={plate?.clientId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setPlate(prevPlate => ({...prevPlate, clientId: selectedValue}));
                            }}
                        />

                        <Form.Select
                            label={'Tipo de Veículo'}
                            options={vehicleTypes}
                            placeholder='Selecione um tipo de veículo'
                            value={plate?.typeId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setPlate(prevPlate => ({...prevPlate, typeId: selectedValue}));
                            }}
                        />

                        <Form.Select
                            label={'Tipo de Frota'}
                            options={fleetTypes}
                            placeholder='Selecione um tipo de frota'
                            value={plate?.fleetTypeId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setPlate(prevPlate => ({...prevPlate, fleetTypeId: selectedValue}));
                            }}
                        />

                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/vehicle-plates/')} grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color="green"/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateVehiclePlate;
